// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './SuggestionPopupContent.scss';

const SuggestionPopupContent = (props) => {
    const { children } = props;

    return <div className="SuggestionPopupContent">{children}</div>;
};

SuggestionPopupContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default SuggestionPopupContent;
